interface Option {
  value: string;
  label: string;
}

interface Props {
  options: readonly Option[];
  value: string | undefined;
  onChange: (v: string) => void;
}

export function RadioGroup({ options, value, onChange }: Props) {
  return (
    <div className="flex flex-col gap-2.5">
      {options.map((opt) => {
        const selected = value === opt.value;
        return (
          <button
            type="button"
            key={opt.value}
            onClick={() => onChange(opt.value)}
            className={`ios-chip text-[15px] ${selected ? "ios-chip-selected" : ""}`}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
